module.exports = __webpack_public_path__ + "img/product25.bed31db3.png";